import { createRouter, createWebHistory } from "vue-router";

import { suporteRoutes } from "./suporteRoutes";
import { ferramentasRoutes } from "./ferramentasRoutes";
import { calendarioRoutes } from "./calendarioRoutes";
import { authRoutes } from "./authRoutes";
import servicosRoutes from "./servicos";

import { useGlobalLoading } from "@/composables/useGlobalLoading";

/* ================================
   🧩 HELPER DE LAZY LOAD
================================ */
const view = (path) => () => import(`@/views/${path}.vue`);

/* ================================
   🧭 ROTAS
================================ */
const routes = [
  // 🏠 PRINCIPAIS
  {
    path: "/",
    name: "home",
    component: view("HomeView"),
    alias: "/home",
    meta: {
      title: "Início",
      loadingTitle: "Carregando Início",
      loadingMessage: "Preparando o conteúdo da Click Sorvetes...",
    },
  },
  {
    path: "/quemsomos",
    name: "quemsomos",
    component: view("QuemsomosView"),
    meta: {
      title: "Quem Somos",
      loadingTitle: "Carregando Quem Somos",
      loadingMessage: "Organizando nossa história e propósito...",
    },
  },
  {
    path: "/manifesto",
    name: "manifesto",
    component: view("ManifestoEmpreendedorView"),
    meta: {
      title: "Manifesto Empreendedor",
      loadingTitle: "Carregando Manifesto",
      loadingMessage: "Abrindo a mensagem do nosso propósito...",
    },
  },

  // 💼 SERVIÇOS
  {
    path: "/locacao",
    name: "locacao-home",
    component: view("servicos/HomeLocacaoView"),
    meta: {
      title: "Locação Mensalista",
      loadingTitle: "Carregando Locação Mensalista",
      loadingMessage: "Preparando as informações de locação mensal...",
    },
  },

  // ✅ NOVA ABA: Festas e Eventos (página explicativa dentro da Click)
  {
    path: "/eventos",
    name: "eventos-home",
    component: view("eventos/HomeEventosView"),
    meta: {
      title: "Locação para Eventos",
      skipLoading: true,
      hideFooter: true, // 👈 ESSENCIAL
    },
  },

  // ✅ NOVA ROTA: Single Page de Eventos (estilo Yeti)
  {
    path: "/eventos/fechamento",
    name: "eventos-single",
    component: view("eventos/LandingPageEventos.vue"),
    meta: {
      title: "Eventos Click Sorvetes",
      loadingTitle: "Carregando Página de Eventos",
      loadingMessage: "Montando os pacotes e detalhes do seu evento...",
    },
  },

  {
    path: "/vendas",
    name: "vendas-home",
    component: view("servicos/HomeVendasView"),
    meta: {
      title: "Vendas de Equipamentos",
      loadingTitle: "Carregando Vendas de Equipamentos",
      loadingMessage: "Preparando as opções de compra e condições...",
    },
  },
  {
    path: "/licenciamento",
    name: "licenciamento-home",
    component: view("servicos/HomeLicenciamentoView"),
    meta: {
      title: "Licenciamento da Marca",
      loadingTitle: "Carregando Licenciamento",
      loadingMessage: "Preparando informações do licenciamento Click...",
    },
  },
  {
    path: "/treinamentos",
    name: "treinamentos-home",
    component: view("servicos/HomeTreinamentosView"),
    meta: {
      title: "Treinamentos",
      loadingTitle: "Carregando Treinamentos",
      loadingMessage: "Carregando trilhas e conteúdos de capacitação...",
    },
  },
  {
    path: "/treinamento-precificacao",
    name: "treinamento-precificacao",
    component: view("treinamentos/TreinamentoPrecificacaoView"),
    meta: {
      title: "Treinamento de Precificação",
      loadingTitle: "Carregando Treinamento",
      loadingMessage: "Preparando o conteúdo de precificação...",
    },
  },
  {
    path: "/obrigado",
    name: "obrigado",
    component: view("ObrigadoView"),
    meta: {
      title: "Obrigado pelo Contato",
      loadingTitle: "Finalizando",
      loadingMessage: "Preparando seu redirecionamento...",
    },
  },

  // ⚙️ MÓDULOS
  ...ferramentasRoutes,
  ...suporteRoutes,
  ...calendarioRoutes,
  ...authRoutes,
  ...servicosRoutes,

  // 🚫 404
  { path: "/:pathMatch(.*)*", redirect: "/" },
];

/* ================================
   🚀 CRIAÇÃO DO ROUTER
================================ */
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL || "/"),
  routes,
  scrollBehavior: () => ({ top: 0 }),
});

/* ================================
   🧱 LAYOUT PADRÃO
================================ */
router.beforeEach((to, from, next) => {
  if (!to.meta.layout) to.meta.layout = "DefaultLayout";
  next();
});

/* ================================
   🔄 LOADING GLOBAL (APENAS ABRE)
   ✅ Cada página fecha quando terminar
================================ */
router.beforeEach((to, from, next) => {
  // 🛑 Se a rota pedir para pular o loading, não abre
  if (to.meta?.skipLoading) {
    next();
    return;
  }

  const { showLoading } = useGlobalLoading();

  showLoading({
    title: to.meta?.loadingTitle || "Carregando página",
    message: to.meta?.loadingMessage || "Aguarde enquanto preparamos o conteúdo.",
    hint: to.meta?.loadingHint || "Isso pode levar alguns segundos.",
    progress: 20,
  });

  next();
});

/* ================================
   🏷️ TÍTULO DA PÁGINA
================================ */
router.afterEach((to) => {
  const base = "Click Sorvetes";
  document.title = to.meta?.title ? `${to.meta.title} | ${base}` : base;
});

export default router;
